import React, { useState, useEffect, useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { TabFooter, useSnackbarContext } from '@ohif/ui';
import { useTranslation } from 'react-i18next';
import {
  getAiPathList,
  getLessonsTypeList,
  getAiBasicSetting,
  addBasicSetting,
  updateBasicSetting,
  getDicCheckListVsAi,
  getResultSetting,
} from './makeData';
import './WindowLevelPreferences.styl';

import './LanguageSwitcher.styl';
import AppContext from '../../context/AppContext';
function AiResultSetting({ onClose }) {
  const { appConfig = {} } = useContext(AppContext);
  const [dicCheckId, setDicCheckId] = useState('');
  const [selectOptions, setSelectOptions] = useState([]);
  const [selectAiOptions, setSelectAiOptions] = useState([]);

  const [selectLessonsTypeOptions, setSelectLessonsTypeOptions] = useState([]);
  const [lessonsType, setLessonsType] = useState('');

  //结果是否显示
  const [result, setResult] = useState('0');
  //轮廓是否显示
  const [outline, setOutline] = useState('0');
  //自定义结果显示
  const [viewResult, setViewResult] = useState(false);

  const [aiAppName, setAiAppName] = useState('');
  const [aiBasicSetting, setAiBasicSetting] = useState(Object);

  // 选择病变种类
  const onSelectLessonsChange = event => {
    console.log(event.target);
    const { value } = event.target;
    console.log(value);
    setLessonsType(value + '');
    getResultSetting(value, appConfig).then(({ data }) => {
      if (data) {
        let obj = Object.assign({}, aiBasicSetting);
        obj.aiResultSettings = data;
        console.log(obj);
        setAiBasicSetting(obj);
      }
    });
  };

  // 获取疾病列表
  const getDicList = useCallback(() => {
    getDicCheckListVsAi(appConfig).then(({ data }) => {
      if (data.length) {
        setSelectOptions(data);
        setDicCheckId(data[0].id + '');
      }
    });
  }, [appConfig]);

  // 获取AI应用
  const getAicList = useCallback(() => {
    if (dicCheckId) {
      getAiPathList(dicCheckId, 0, 0, appConfig).then(({ data }) => {
        if (data.records.length) {
          setSelectAiOptions(data.records);
          setAiAppName(data.records[0].myAiInfo.myAiInfoId);
          getAiBasic();
        }
      });
    }
  }, [appConfig, dicCheckId, getAiBasic]);

  // 获取AI基础信息和冰壁那结果项
  const getAiBasic = useCallback(() => {
    getAiBasicSetting(aiAppName, dicCheckId, appConfig).then(({ data }) => {
      console.log('data', data);
      if (data) {
        setAiBasicSetting(data);
        data.basicSetting.lesionTypeId &&
          setLessonsType(data.basicSetting.lesionTypeId);
        data.basicSetting.viewResult && setResult(data.basicSetting.viewResult);
        data.basicSetting.viewOutline &&
          setOutline(data.basicSetting.viewOutline);
      }
    });
  }, [aiAppName, appConfig, dicCheckId]);

  const fetchLessonsTypes = useCallback(() => {
    getLessonsTypeList('', appConfig).then(({ data }) => {
      setSelectLessonsTypeOptions(data);
      setLessonsType(data[0].id);
    });
  }, [appConfig]);

  useEffect(() => {
    getDicList();
    fetchLessonsTypes();
  }, [fetchLessonsTypes, getDicList]);

  useEffect(() => {
    getAicList();
  }, [getAicList]);

  const snackbar = useSnackbarContext();

  // 选择疾病
  const dicChange = e => {
    setDicCheckId(e.target.value);
    console.log(dicCheckId);
  };
  // 选择ai应用
  const onSelectChange = event => {
    console.log(event.target.value);
    setAiAppName(event.target.value);
    getAiBasic();
  };

  const { t } = useTranslation('UserPreferencesModal');
  const hasErrors = false;
  return (
    <>
      <div
        style={{
          marginLeft: '-10px',
          marginTop: '20px',
          display: 'inlineBlock',
        }}
      >
        <select
          name="language-select"
          id="language-select"
          className="language-select"
          value={dicCheckId}
          onChange={dicChange}
          style={{
            height: '40px',
            marginLeft: '20px',
            textAlign: 'center',
          }}
        >
          {selectOptions.map(lng => (
            <option key={lng.description} value={lng.id}>
              {lng.description}
            </option>
          ))}
        </select>
      </div>

      <div className="WindowLevelPreferences">
        <div className="wlColumn">
          {/* AI应用模块 */}
          <div className="wlRow">
            <div className="wlColumn window">
              <input
                type="text"
                className="preferencesInput"
                value={'AI应用'}
                data-inputname="description"
                disabled={true}
              />
            </div>

            <div className="wlColumn description">
              <select
                name="language-select"
                id="language-select"
                className="preferencesInput"
                value={aiAppName}
                onChange={onSelectChange}
                style={{
                  height: '40px',
                  marginLeft: '20px',
                }}
              >
                {selectAiOptions.length
                  ? selectAiOptions.map((lng, i) => (
                      <option
                        key={lng.myAiInfo.aiAppId + i}
                        value={lng.myAiInfo.myAiInfoId}
                      >
                        {lng.myAiInfo.name}
                      </option>
                    ))
                  : ''}
              </select>
            </div>
          </div>

          {/* 病变种类 */}
          <div className="wlRow">
            <div className="wlColumn window">
              <input
                type="text"
                className="preferencesInput"
                value={'病变种类'}
                data-inputname="description"
                disabled={true}
              />
            </div>

            <div className="wlColumn description">
              <select
                name="language-select"
                id="language-select"
                className="preferencesInput"
                value={lessonsType}
                onChange={onSelectLessonsChange}
                style={{
                  height: '40px',
                  marginLeft: '20px',
                }}
              >
                {selectLessonsTypeOptions.length
                  ? selectLessonsTypeOptions.map(lng => (
                      <option key={lng.id} value={lng.id}>
                        {lng.name}
                      </option>
                    ))
                  : null}
              </select>
            </div>
          </div>

          {/* 结果 */}
          <div className="wlRow">
            <div className="wlColumn window">
              <input
                type="text"
                className="preferencesInput"
                value={'结果'}
                data-inputname="description"
                disabled={true}
              />
            </div>

            <div className="wlColumn description">
              <button
                className="preferencesInput"
                style={{
                  height: '40px',
                  marginLeft: '20px',
                }}
                onClick={() => {
                  setResult(result == '1' ? '0' : '1');
                }}
              >
                {result == '0' ? (
                  <svg
                    width="18px"
                    height="12px"
                    viewBox="0 0 18 12"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <title>眼睛 (1)备份</title>
                    <g
                      id="页面-1"
                      stroke="none"
                      strokeWidth="1"
                      fill="none"
                      fillRule="evenodd"
                    >
                      <g
                        id="Viewer---2.0-1备份"
                        transform="translate(-1148.000000, -274.000000)"
                        fill="#8ECFFD"
                        fillRule="nonzero"
                      >
                        <g
                          id="编组-8"
                          transform="translate(737.000000, 145.000000)"
                        >
                          <g
                            id="眼睛-(1)备份"
                            transform="translate(411.000000, 129.000000)"
                          >
                            <path
                              d="M8.99999999,1.45454545 C12.3409197,1.45454545 15.3834174,4.69949769 16.5454545,6.09090909 C15.3834174,7.4823205 12.3409197,10.7272727 8.99999999,10.7272727 C5.6590803,10.7272727 2.61658263,7.4823205 1.45454545,6.09090909 C2.61658263,4.69949769 5.65908032,1.45454545 8.99999999,1.45454545 Z M9,0 C4.87402399,0 1.37804431,3.93699999 0.199051162,5.43250001 C-0.0663503873,5.76428787 -0.0663503873,6.23571213 0.199051162,6.56749999 C1.37804431,8.06300001 4.87402399,12 9,12 C13.125976,12 16.6219557,8.06299999 17.8009488,6.56749999 C18.0663504,6.23571213 18.0663504,5.76428787 17.8009488,5.43250001 C16.6219557,3.93699999 13.125976,0 9,0 Z M9,4.72727273 C9.75303031,4.72727273 10.3636364,5.33770922 10.3636364,6.09090909 C10.3636364,6.84410896 9.75303031,7.45454545 9,7.45454545 C8.24696969,7.45454545 7.63636364,6.84410896 7.63636364,6.09090909 C7.63636364,5.33770922 8.24696969,4.72727273 9,4.72727273 Z M9.09074512,3.27272727 C7.98764849,3.27272727 6.99314426,3.93713407 6.57140175,4.95664632 C6.14915414,5.97615859 6.38250151,7.14884395 7.16234637,7.92899247 C7.93192314,8.70703988 9.11367307,8.94205476 10.1342422,8.52001409 C11.1534954,8.09841867 11.8181818,7.10353231 11.8181818,6.00029197 C11.8181818,4.49367939 10.5974014,3.27272727 9.09125021,3.27272727 L9.09074512,3.27272727 Z"
                              id="形状"
                            ></path>
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>
                ) : null}

                {result == '1' ? (
                  <svg
                    width="18px"
                    height="9px"
                    viewBox="0 0 18 9"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <title>闭眼</title>
                    <g
                      id="页面-1"
                      stroke="none"
                      strokeWidth="1"
                      fill="none"
                      fillRule="evenodd"
                    >
                      <g
                        id="Viewer---2.0-1备份"
                        transform="translate(-1148.000000, -237.000000)"
                        fill="#8ECFFD"
                        fillRule="nonzero"
                      >
                        <g
                          id="编组-8"
                          transform="translate(737.000000, 145.000000)"
                        >
                          <g
                            id="闭眼"
                            transform="translate(411.000000, 92.000000)"
                          >
                            <path
                              d="M17.8881429,1.05717857 C18.0760869,0.765856415 18.0212965,0.380679273 17.7595714,0.153321429 C17.4702857,-0.0729642857 17.0832857,-0.00867857143 16.8582857,0.281892857 C16.8261429,0.314035714 13.2531429,4.54532143 9.00385714,4.54532143 C4.88314286,4.54532143 1.14942857,0.281892857 1.11728571,0.24975 C0.882849698,-0.010198022 0.484957461,-0.0385783528 0.216,0.185464286 C-0.043004836,0.421412938 -0.0712891603,0.819090537 0.151714286,1.08932143 C0.214714286,1.18703571 0.987428571,2.05875 2.21142857,3.02689286 L0.569571429,4.73946429 C0.450521835,4.86187898 0.38663203,5.0276045 0.392700655,5.19825424 C0.39876928,5.36890399 0.474269828,5.52967253 0.601714286,5.64332143 C0.666,5.77189286 0.826714286,5.83746429 0.987428571,5.83746429 C1.15748367,5.83613826 1.3197798,5.76611907 1.43742857,5.64332143 L3.20785714,3.80217857 C4.11295608,4.43485696 5.09778788,4.9449981 6.13671429,5.31932143 L5.46171429,7.61303571 C5.41203606,7.77999474 5.43195259,7.95994519 5.51693857,8.11199987 C5.60192454,8.26405455 5.74476333,8.37530164 5.913,8.42048549 L6.10585714,8.42048549 C6.39844295,8.42286547 6.65318159,8.22110819 6.71785714,7.93575 L7.39285714,5.64332143 C7.90842857,5.73975 8.45485714,5.80532143 9.00257143,5.80532143 C9.55028571,5.80532143 10.0967143,5.74103571 10.6122857,5.64332143 L11.2885714,7.90360714 C11.3528571,8.19417857 11.6421429,8.38832143 11.9005714,8.38832143 C11.9648571,8.38832143 12.0291429,8.38832143 12.0612857,8.35617857 C12.2293229,8.31070172 12.3719302,8.19940105 12.4568621,8.04744308 C12.5417941,7.89548511 12.5618775,7.71570378 12.5125714,7.54875 L11.8362857,5.28846429 C12.8754981,4.91423876 13.8603971,4.40363044 14.7651429,3.77003571 L16.5034286,5.57903571 C16.632,5.70760714 16.7927143,5.77317857 16.9547143,5.77317857 C17.1247694,5.77185255 17.2870655,5.70183336 17.4047143,5.57903571 C17.654741,5.33452634 17.6688838,4.93683067 17.4368571,4.67517857 L15.795,2.96389286 C17.1154286,1.99446429 17.8881429,1.05717857 17.8881429,1.05717857 L17.8881429,1.05717857 Z"
                              id="路径"
                            ></path>
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>
                ) : null}
              </button>
            </div>
          </div>

          {/* 轮廓 */}
          <div className="wlRow">
            <div className="wlColumn window">
              <input
                type="text"
                className="preferencesInput"
                value={'轮廓'}
                data-inputname="description"
                disabled={true}
              />
            </div>

            <div className="wlColumn description">
              <button
                className="preferencesInput"
                style={{
                  height: '40px',
                  marginLeft: '20px',
                }}
                onClick={() => {
                  setOutline(outline == '1' ? '0' : '1');
                }}
              >
                {outline == '0' ? (
                  <svg
                    width="18px"
                    height="12px"
                    viewBox="0 0 18 12"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <title>眼睛 (1)备份</title>
                    <g
                      id="页面-1"
                      stroke="none"
                      strokeWidth="1"
                      fill="none"
                      fillRule="evenodd"
                    >
                      <g
                        id="Viewer---2.0-1备份"
                        transform="translate(-1148.000000, -274.000000)"
                        fill="#8ECFFD"
                        fillRule="nonzero"
                      >
                        <g
                          id="编组-8"
                          transform="translate(737.000000, 145.000000)"
                        >
                          <g
                            id="眼睛-(1)备份"
                            transform="translate(411.000000, 129.000000)"
                          >
                            <path
                              d="M8.99999999,1.45454545 C12.3409197,1.45454545 15.3834174,4.69949769 16.5454545,6.09090909 C15.3834174,7.4823205 12.3409197,10.7272727 8.99999999,10.7272727 C5.6590803,10.7272727 2.61658263,7.4823205 1.45454545,6.09090909 C2.61658263,4.69949769 5.65908032,1.45454545 8.99999999,1.45454545 Z M9,0 C4.87402399,0 1.37804431,3.93699999 0.199051162,5.43250001 C-0.0663503873,5.76428787 -0.0663503873,6.23571213 0.199051162,6.56749999 C1.37804431,8.06300001 4.87402399,12 9,12 C13.125976,12 16.6219557,8.06299999 17.8009488,6.56749999 C18.0663504,6.23571213 18.0663504,5.76428787 17.8009488,5.43250001 C16.6219557,3.93699999 13.125976,0 9,0 Z M9,4.72727273 C9.75303031,4.72727273 10.3636364,5.33770922 10.3636364,6.09090909 C10.3636364,6.84410896 9.75303031,7.45454545 9,7.45454545 C8.24696969,7.45454545 7.63636364,6.84410896 7.63636364,6.09090909 C7.63636364,5.33770922 8.24696969,4.72727273 9,4.72727273 Z M9.09074512,3.27272727 C7.98764849,3.27272727 6.99314426,3.93713407 6.57140175,4.95664632 C6.14915414,5.97615859 6.38250151,7.14884395 7.16234637,7.92899247 C7.93192314,8.70703988 9.11367307,8.94205476 10.1342422,8.52001409 C11.1534954,8.09841867 11.8181818,7.10353231 11.8181818,6.00029197 C11.8181818,4.49367939 10.5974014,3.27272727 9.09125021,3.27272727 L9.09074512,3.27272727 Z"
                              id="形状"
                            ></path>
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>
                ) : null}

                {outline == '1' ? (
                  <svg
                    width="18px"
                    height="9px"
                    viewBox="0 0 18 9"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <title>闭眼</title>
                    <g
                      id="页面-1"
                      stroke="none"
                      strokeWidth="1"
                      fill="none"
                      fillRule="evenodd"
                    >
                      <g
                        id="Viewer---2.0-1备份"
                        transform="translate(-1148.000000, -237.000000)"
                        fill="#8ECFFD"
                        fillRule="nonzero"
                      >
                        <g
                          id="编组-8"
                          transform="translate(737.000000, 145.000000)"
                        >
                          <g
                            id="闭眼"
                            transform="translate(411.000000, 92.000000)"
                          >
                            <path
                              d="M17.8881429,1.05717857 C18.0760869,0.765856415 18.0212965,0.380679273 17.7595714,0.153321429 C17.4702857,-0.0729642857 17.0832857,-0.00867857143 16.8582857,0.281892857 C16.8261429,0.314035714 13.2531429,4.54532143 9.00385714,4.54532143 C4.88314286,4.54532143 1.14942857,0.281892857 1.11728571,0.24975 C0.882849698,-0.010198022 0.484957461,-0.0385783528 0.216,0.185464286 C-0.043004836,0.421412938 -0.0712891603,0.819090537 0.151714286,1.08932143 C0.214714286,1.18703571 0.987428571,2.05875 2.21142857,3.02689286 L0.569571429,4.73946429 C0.450521835,4.86187898 0.38663203,5.0276045 0.392700655,5.19825424 C0.39876928,5.36890399 0.474269828,5.52967253 0.601714286,5.64332143 C0.666,5.77189286 0.826714286,5.83746429 0.987428571,5.83746429 C1.15748367,5.83613826 1.3197798,5.76611907 1.43742857,5.64332143 L3.20785714,3.80217857 C4.11295608,4.43485696 5.09778788,4.9449981 6.13671429,5.31932143 L5.46171429,7.61303571 C5.41203606,7.77999474 5.43195259,7.95994519 5.51693857,8.11199987 C5.60192454,8.26405455 5.74476333,8.37530164 5.913,8.42048549 L6.10585714,8.42048549 C6.39844295,8.42286547 6.65318159,8.22110819 6.71785714,7.93575 L7.39285714,5.64332143 C7.90842857,5.73975 8.45485714,5.80532143 9.00257143,5.80532143 C9.55028571,5.80532143 10.0967143,5.74103571 10.6122857,5.64332143 L11.2885714,7.90360714 C11.3528571,8.19417857 11.6421429,8.38832143 11.9005714,8.38832143 C11.9648571,8.38832143 12.0291429,8.38832143 12.0612857,8.35617857 C12.2293229,8.31070172 12.3719302,8.19940105 12.4568621,8.04744308 C12.5417941,7.89548511 12.5618775,7.71570378 12.5125714,7.54875 L11.8362857,5.28846429 C12.8754981,4.91423876 13.8603971,4.40363044 14.7651429,3.77003571 L16.5034286,5.57903571 C16.632,5.70760714 16.7927143,5.77317857 16.9547143,5.77317857 C17.1247694,5.77185255 17.2870655,5.70183336 17.4047143,5.57903571 C17.654741,5.33452634 17.6688838,4.93683067 17.4368571,4.67517857 L15.795,2.96389286 C17.1154286,1.99446429 17.8881429,1.05717857 17.8881429,1.05717857 L17.8881429,1.05717857 Z"
                              id="路径"
                            ></path>
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>
                ) : null}
              </button>
            </div>
          </div>

          {/* 病变结果项目 */}
          <div className="wlRow">
            <div className="wlColumn window">
              <input
                type="text"
                className="preferencesInput"
                value={'病变结果项'}
                data-inputname="description"
                disabled={true}
              />
            </div>

            <div className="wlColumn description">
              <button
                style={{
                  height: '40px',
                  marginLeft: '20px',
                }}
                className="preferencesInput"
                onClick={() => {
                  setViewResult(viewResult ? false : true);
                }}
              >
                自定义
              </button>
            </div>
          </div>
        </div>
      </div>

      {viewResult && (
        <div className="WindowLevelPreferences">
          <div className="wlColumn">
            <div className="wlRow header">
              <div className="wlColumn preset">序号</div>
              {/* <div className="wlColumn description">项目编号</div> */}
              <div className="wlColumn description">类型</div>
              <div className="wlColumn description">项目名称</div>
              <div className="wlColumn description">有无此项</div>
              <div className="wlColumn description">是否显示</div>
            </div>

            {aiBasicSetting.aiResultSettings.length
              ? aiBasicSetting.aiResultSettings.map((item, key) => {
                  return (
                    <div className="wlRow" key={key}>
                      <div className="wlColumn preset">{parseInt(key) + 1}</div>
                      <div className="wlColumn description">
                        <input
                          type="text"
                          className="preferencesInput"
                          value={item.type}
                          data-key={key}
                          data-inputname="description"
                          disabled={true}
                        />
                      </div>

                      <div className="wlColumn description">
                        <input
                          type="text"
                          className="preferencesInput"
                          value={item.projectName}
                          data-key={key}
                          data-inputname="description"
                          disabled={true}
                        />
                      </div>

                      <div className="wlColumn description">
                        <p
                          onClick={() => {
                            if (item.views === '2') return;
                            const newS = Object.assign({}, aiBasicSetting);
                            newS.aiResultSettings[key].have = !newS
                              .aiResultSettings[key].have;
                            setAiBasicSetting(newS);
                          }}
                          style={{
                            backgroundColor: '#263340',
                            height: '43px',
                            lineHeight: '43px',
                            cursor: 'pointer',
                            outline,
                          }}
                        >
                          {item.have ? '有' : '无'}
                        </p>
                      </div>

                      <div className="wlColumn description">
                        <select
                          className="preferencesInput"
                          value={item.views}
                          onChange={event => {
                            const { value } = event.target;
                            const aiResultSettings$ = Object.assign(
                              {},
                              aiBasicSetting
                            );
                            aiResultSettings$.aiResultSettings[
                              key
                            ].views = value;
                            setAiBasicSetting(aiResultSettings$);
                          }}
                          disabled={item.views == 2}
                        >
                          <option key={2} value={2} disabled={true}>
                            默认
                          </option>
                          <option key={0} value={0}>
                            是
                          </option>
                          <option key={1} value={1}>
                            否
                          </option>
                        </select>
                      </div>
                    </div>
                  );
                })
              : ''}
          </div>
        </div>
      )}
      <TabFooter
        onResetPreferences={() => {
          snackbar.show({
            message: '默认推荐暂未开发...',
            type: 'success',
          });
        }}
        onSave={() => {
          console.log(aiAppName);
          console.log(lessonsType);
          //新增
          const paylod = Object.assign({}, aiBasicSetting);
          paylod.basicSetting.aiInfoId = aiAppName;
          paylod.basicSetting.lesionTypeId = lessonsType;
          paylod.basicSetting.viewResult = result;
          paylod.basicSetting.viewOutline = outline;
          if (!aiBasicSetting.basicSetting.id) {
            addBasicSetting(paylod, appConfig).then(data => {
              snackbar.show({
                message: '基础设置添加成功',
                type: 'success',
              });
            });
          } else {
            updateBasicSetting(paylod, appConfig).then(data => {
              snackbar.show({
                message: '基础设置更新成功',
                type: 'success',
              });
            });
          }
        }}
        onCancel={onClose}
        hasErrors={hasErrors}
        t={t}
      />
    </>
  );
}

AiResultSetting.propTypes = {
  onClose: PropTypes.func,
};

export { AiResultSetting };
